import { defineNuxtPlugin } from 'nuxt/app';

export default defineNuxtPlugin(() => {
  const { handleNonRecoverableAuth } = useAuth();

  globalThis.$fetch = $fetch.create({
    async onResponseError({ response }) {
      if (response.status === 401) {
        await handleNonRecoverableAuth({ reason: 'session_expired' });
      }
    },
  });
});
